import { AuthService } from 'src/app/auth/services/auth.service';
import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/core/services/data.service';
import { InsuranceService } from 'src/app/core/services/insurance.service';
import { IPolicyResponse } from '@interfaces/policy-response.interface';
import { ISiniestroResponse } from '@interfaces/siniestro-response.interface';
import { Router } from '@angular/router';
import { UserInterface } from 'src/app/auth/interfaces/user-interface';
import { CardComponent } from 'src/app/shared/components/card/card.component';
import { ICard } from '@interfaces/card-interface';
import { IValidarSiniestro } from '@interfaces/validar-siniestro.interface';
import { ISiniestroRequest } from '@interfaces/siniestro-request.interface';
import { ModalNewClaimComponent } from '../../components/modal-new-claim/modal-new-claim.component';
import { ModalRejectedComponent } from '../../components/modal-rejected/modal-rejected.component';

@Component({
  selector: 'aig-client-area',
  imports: [
    CommonModule,
    CardComponent,
    ModalNewClaimComponent,
    ModalRejectedComponent,
  ],
  templateUrl: './client-area.component.html',
  styleUrl: './client-area.component.scss',
})
export class ClientAreaComponent implements OnInit {
  //#region Variables

  public policyResponse: IPolicyResponse[] = []; // Las pólizas obtenidas previamente
  public claimResponse: ISiniestroResponse[] = []; // Los siniestros obtenidos previamente

  public IdPoliza: number | null = null;
  public usuario!: UserInterface;

  public visibleNewClaimModal: boolean = false;
  rejectedClaimModalVisible: any;

  // isPolicyActive = this.policiesDto.filter(p => p.idEstado == 1).length != 0;
  // isPolicyRest = this.policiesDto.filter(p => p.idEstado != 1).length != 0;
  // isClaim = this.claimDto.length != 0;

  get isPolicyActive(): boolean {
    return this.policyResponse.filter((p) => p.idEstado === 1).length !== 0;
  }

  get isPolicyRest(): boolean {
    //console.log(this.policyResponse);
    var _is = this.policyResponse.filter((p) => p.idEstado !== 1).length !== 0;
    //console.log(_is);
    return _is;
  }

  get isClaim(): boolean {
    return this.claimResponse.length !== 0;
  }

  claimPolicy: any[] = [];

  activePolicies: IPolicyResponse[] = [];
  restPolicies: IPolicyResponse[] = [];
  policies: IPolicyResponse[] = [];

  cardActivedPolicies: ICard[] = [];
  cardRestPolicies: ICard[] = [];
  cardClaims: ICard[] = [];

  resultado?: IValidarSiniestro;

  policyState(arg: number | undefined): string {
    switch (arg) {
      case 1:
        return '';
      case 2:
        return 'cancel';
      case 3:
        return 'inactive';
      case 5:
        return 'inactive';
      case 6:
        return 'inactive';
      default:
        return '';
    }
  }

  claimState(arg: number | undefined): string {
    switch (arg) {
      case 2:
        return '';
      case 3:
        return 'cancel';
      case 4:
        return 'finish';
      default:
        return '';
    }
  }

  //#region Constructor & life-cycle hooks
  constructor(
    private insuranceService: InsuranceService,
    private router: Router,
    private authService: AuthService,
    private dataService: DataService
  ) {
    // this.SetPolicyCards();
    // this.SetClaimCards();
  }

  ngOnInit(): void {
    this.cargarFormulario();
  }
  //#endregion

  //#region Public methods
  public cargarFormulario() {
    console.log('cargarFormulario');
    this.authService.getUsuario().subscribe({
      next: (data) => {
        this.usuario = data; // Asignamos el usuario recibido
        console.log(this.usuario);
        if (this.usuario) {
          const numDocumento = this.usuario.num_documento;

          if (!numDocumento) {
            alert('Debe ingresar un número de documento.');
            return;
          }

          if (!numDocumento) {
            console.error(
              'No se encontró el número de documento en el almacenamiento local.'
            );
            return;
          }

          this.insuranceService.obtenerPolizas(numDocumento).subscribe({
            next: (data) => {
              this.policyResponse = Array.isArray(data) ? data : [data];

              this.IdPoliza =
                this.policyResponse.find((p) => p.idEstado === 1)?.idPoliza ??
                null;

              this.dataService.setNumDocumento(numDocumento);

              if (this.IdPoliza) this.dataService.setPoliza(this.IdPoliza);

              this.SetPolicyCards();

              this.insuranceService
                .obtenerSiniestros({ numDocumento: numDocumento })
                .subscribe({
                  next: (claims) => {
                    this.claimResponse = claims;
                    this.SetClaimCards();
                  },
                  error: (err) => {
                    console.error('Error al obtener siniestros:', err);
                  },
                });
            },
            error: (error) => {
              console.error('Error al obtener datos de póliza:', error);
            },
            complete: () => {},
          });
        } else {
          this.router.navigate(['auth/login']);
        }
      },
      error: (error) => {
        console.error('Error al obtener usuario:', error);
      },
    });
  }

  private SetPolicyCards(): void {
    console.log('SetPolicyCards');
    const active = this.policyResponse.filter((p) => p.idEstado === 1);
    const rest = this.policyResponse.filter((p) => p.idEstado !== 1);

    this.activePolicies = active;
    this.restPolicies = rest;

    this.cardActivedPolicies = active.map((p) => ({
      card_id: p.idPoliza,
      tag: {
        tag_label: p.estado_Poliza,
        tag_id: p.idEstado,
      },
      button: {
        button_label: 'Ver detalle de la póliza',
        button_class: 'e-btn--primary',
      },
    }));

    console.log(this.restPolicies);

    this.cardRestPolicies = rest.map((p) => ({
      card_id: p.idPoliza,
      tag: {
        tag_label: p.estado_Poliza,
        tag_id: p.idEstado,
        tag_type: this.policyState(p.idEstado),
      },
      button: {
        button_label: 'Ver detalle de la póliza',
        button_class: 'e-btn--secondary',
      },
    }));

    console.log(this.cardRestPolicies);
  }

  private SetClaimCards(): void {
    const claim = this.claimResponse.map((c) => ({
      ...c,
      policy: this.policyResponse.filter((p) => p.idPoliza === c.idPoliza),
    }));

    this.claimPolicy = claim;

    this.cardClaims = claim.map((c) => ({
      card_id: c.idExpediente,
      tag: {
        tag_label: c.estadoExpediente,
        tag_id: c.idEstadoExpediente,
        tag_type: this.claimState(c.idEstadoExpediente),
      },
      button: {
        button_label: 'Ver estado del siniestro',
        button_class: 'e-btn--secondary',
      },
    }));
  }

  //#region Navigation
  public goToHistoryPolicy() {
    this.router.navigate(['/area-cliente/historial-polizas']);
    // location.replace('/area-cliente/historial-polizas');
  }

  public goToNewClaim() {
    if (this.IdPoliza === null) {
      console.error('Error: IdPoliza es null');
      return; // No continuar si es null
    }

    this.insuranceService
      .validarAperturaSiniestro(this.IdPoliza)
      .subscribe((data) => {
        this.resultado = data;
        if (
          this.resultado.estadoPoliza == 1 &&
          this.resultado.siniestroCurso == false
        ) {
          this.visibleNewClaimModal = true;
        } else {
          this.abrirSiniestroRechazado(data);
          this.rejectedClaimModalVisible = true;
          // resultado.existenSiniestros está disponible aquí
        }
      });
  }

  public goToClaimManagement() {
    if (this.IdPoliza === null) {
      console.error('Error: IdPoliza es null');
      return; // No continuar si es null
    }

    this.insuranceService
      .validarAperturaSiniestro(this.IdPoliza)
      .subscribe((data) => {
        this.resultado = data;
        if (this.resultado.existenSiniestros == true) {
          this.router.navigate(['/area-cliente/gestion-siniestros']);
          //location.replace('/area-cliente/gestion-siniestros');
        } else if (
          this.resultado.estadoPoliza == 1 &&
          this.resultado.siniestroCurso == false &&
          this.resultado.existenSiniestros == false
        ) {
          this.visibleNewClaimModal = true;
        } else {
          this.abrirSiniestroRechazado(data);
          this.rejectedClaimModalVisible = true;
          // resultado.existenSiniestros está disponible aquí
        }
      });
  }

  public CloseNewClaim() {
    this.visibleNewClaimModal = false;
  }

  public goToModifyPolicy(): void {
    this.router.navigate(['/area-cliente/modificar-datos'], {
      state: { policy: this.policyResponse },
    });
    location.replace('/area-cliente/modificar-datos');
  }

  public goToPoliceDetail(policy: IPolicyResponse) {
    this.router.navigate(['/area-cliente/historial-polizas/detalles'], {
      state: { policy: policy },
    });
    location.replace('/area-cliente/historial-polizas/detalles');
  }

  public goToClaimState(claim: ISiniestroResponse) {
    this.router.navigate(['/area-cliente/gestion-siniestros/estado'], {
      state: { claim: claim },
    });
    location.replace('/area-cliente/gestion-siniestros/estado');
  }

  public abrirSiniestroRechazado(data: IValidarSiniestro) {
    const request: ISiniestroRequest = {
      idPoliza: data.idPoliza,
      puedeAbrirSiniestro: false,
      siniestroCurso: data.siniestroCurso,
      estadoPoliza: data.estadoPoliza,
    };

    console.log(request);

    this.insuranceService.aperturaSiniestro(request).subscribe({
      next: (response) => {
        console.log('Respuesta:', response);
        // this.isloading = false;
      },
      error: (err) => {
        console.log('Error:', err);
        // this.isloading = false;
        // this.submiterror = 'ha ocurrido un error, por favor revisa los datos e inténtalo de nuevo.';
        // puedes mostrar el error en el template
      },
    });
  }

  onCloseModalRejectedClaim(): void {
    this.rejectedClaimModalVisible = false;
  }

  //#endregion
  //#endregion
}
